'use client'
import { Dialog, useMediaQuery, useTheme } from '@mui/material'
import { useDialogData } from 'src/context/DialogContext'
import Section6 from 'src/views/Section6'

export default function DialogComponent() {
  const theme = useTheme()
  const sm = useMediaQuery(theme.breakpoints.down('sm'))
  const { show, setShow, fromAprio } = useDialogData()
  const handleClose = () => setShow(false)

  return (
    <div>
      <Dialog
        open={show}
        onClose={handleClose}
        fullScreen={sm}
        PaperProps={{
          sx: {
            position: 'fixed',
            top: 0,
            maxWidth: '100%',
            maxHeight: {
              xs: '100vh',
              sm: '90vh',
              lg: '95vh'
            }
          }
        }}>
        <Section6 onClose={handleClose} small fromAprio={fromAprio} />
      </Dialog>
    </div>
  )
}
